<template>
  <b-modal v-model="isModalActive" :id="'sideBar' + $store.state.sidebar" :can-cancel="false">
    <div class="form-modal-widget">
      <div class="form-modal-header">
        <h1 v-if="!form.id">ADD NEW EVENT</h1>
        <h1 v-else>UPDATE EVENT</h1>
      </div>

      <div class="form-modal-body">
        <div class="row">
          <b-field label="Title" style="width: 100%">
            <b-input v-model="form.title"></b-input>
          </b-field>
        </div>

        <div class="row" style="margin: 10px 0;border: 1px solid #ddd;padding:6px;border-radius: 5px;">
          <b-field label="Has Sub Event" style="width: 100%">
            <b-switch v-model="hasSubEventComputed">
            </b-switch>
          </b-field>
        </div>

        <div class="row" style="margin-bottom: 20px;border: 1px solid #ddd;padding:6px;border-radius: 5px;">
          <b-field label="Season Enabled" style="width: 100%">
            <b-switch v-model="form.seasonEnabled">
            </b-switch>
          </b-field>
          <div class="h-spacer" v-if="form.seasonEnabled"></div>
          <b-field label="Season Count" v-if="form.seasonEnabled" style="width: 100%">
            <b-numberinput v-model="form.seasonCount" expanded min="1" controls-position="compact"></b-numberinput>
          </b-field>
        </div>


        <div class="row" v-if="!hasSubEventComputed">
          <b-field label="Start Time" style="width: 100%">
            <b-datetimepicker v-model="dates.start_date.selected_date" placeholder="Click to select..."
              icon="calendar-today" :min-datetime="dates.start_date.min_date"
              :icon-right="dates.start_date.selected_date ? 'close-circle' : ''" icon-right-clickable
              :locale="dates.start_date.locale" :first-day-of-week="dates.start_date.firstDayOfWeek"
              :datepicker="{ showWeekNumber: dates.start_date.showWeekNumber }" :timepicker="{
                enableSeconds: dates.start_date.enableSeconds,
                hourFormat: dates.start_date.hourFormat,
              }" horizontal-time-picker position="is-bottom-right">
            </b-datetimepicker>
          </b-field>
          <div class="h-spacer"></div>
          <b-field label="End Time" style="width: 100%">
            <b-datetimepicker v-model="dates.end_date.selected_date" :min-datetime="dates.start_date.selected_date"
              placeholder="Click to select..." icon="calendar-today"
              :icon-right="dates.end_date.selected_date ? 'close-circle' : ''" icon-right-clickable
              :locale="dates.end_date.locale" :first-day-of-week="dates.end_date.firstDayOfWeek"
              :datepicker="{ showWeekNumber: dates.end_date.showWeekNumber }" :timepicker="{
                enableSeconds: dates.end_date.enableSeconds,
                hourFormat: dates.end_date.hourFormat,
              }" horizontal-time-picker position="is-bottom-left">
            </b-datetimepicker>
          </b-field>
        </div>



        <div class="row">
          <b-field label="Description" style="width: 100%">
            <VueEditor v-model="form.description"></VueEditor>
          </b-field>
        </div>

        <b-field label="Logo Image">
          <upload-trigger :open="false" :enableinput="false" :required="false" :multiple="false"
            location="assets/uploaded/" :url="$store.state.ASSETS_BASE_URL"
            :uploadurl="$store.state.BASE_URL + 'upload'" name="main-image" :value="form.logo" @onFileSelected="(file) => {
              form.logo = file;
            }
            ">
            <div class="image-upload-widget">Choose Image to upload</div>
          </upload-trigger>
        </b-field>
        <b-field label="Cover Image">
          <upload-trigger :open="false" :enableinput="false" :required="false" :multiple="false"
            location="assets/uploaded/" :url="$store.state.ASSETS_BASE_URL"
            :uploadurl="$store.state.BASE_URL + 'upload'" name="main-image" :value="form.image" @onFileSelected="(file) => {
              form.image = file;
            }
            ">
            <div class="image-upload-widget">Choose Image to upload</div>
          </upload-trigger>
        </b-field>

        <div class="row">
          <b-field label="Organizer" style="width: 100%">
            <b-input v-model="form.organizers"></b-input>
          </b-field>
        </div>
        <div class="row">
          <b-field label="Category" style="width: 100%">
            <b-input v-model="form.category"></b-input>
          </b-field>
        </div>
        <div class="row">
          <b-field label="Booking Link" style="width: 100%">
            <b-input v-model="form.bookingLink"></b-input>
          </b-field>
        </div>
        <div class="row">
          <b-field label="Custom USSD" style="width: 100%">
            <b-input v-model="form.customUssd"></b-input>
          </b-field>
        </div>
    
        <!-- Sub Events Section -->
        <div v-if="form.hasSubEvent" class="sub-events-section"
          style="margin: 20px 0;border: 1px solid #ddd;padding: 15px;border-radius: 5px;">
          <h3 style="margin-bottom: 15px;color: #333;">Sub Events</h3>

          <div v-for="(subEvent, index) in form.subEvents" :key="index" class="sub-event-item"
            style="margin-bottom: 20px;padding: 15px;border: 1px solid #eee;border-radius: 5px;background: #f9f9f9;">
            <div class="row">
              <b-field label="Title" style="width: 100%">
                <b-input v-model="subEvent.title" placeholder="Sub event title (shown on USSD)"></b-input>
              </b-field>
            </div>
            <div class="row">
              <b-field label="Image" style="width: 100%">
                <upload-trigger :open="false" :enableinput="false" :required="false" :multiple="false"
                  location="assets/uploaded/" :url="$store.state.ASSETS_BASE_URL"
                  :uploadurl="$store.state.BASE_URL + 'upload'" :name="'sub-event-image-' + index" :value="subEvent.image"
                  @onFileSelected="(file) => { subEvent.image = file; }">
                  <div class="image-upload-widget">Choose Image to upload</div>
                </upload-trigger>
              </b-field>
            </div>
            <div class="row">
              <b-field label="Location" style="width: 100%">
                <b-input v-model="subEvent.location"></b-input>
              </b-field>
              <div class="h-spacer"></div>
              <b-field label="Venue" style="width: 100%">
                <b-input v-model="subEvent.venue"></b-input>
              </b-field>
            </div>
            <div class="row">
            </div>
            <div class="row">
              <b-field label="Start Date Time" style="width: 100%">
                <b-datetimepicker v-model="subEvent.startDateTime" placeholder="Click to select..."
                  icon="calendar-today" :min-datetime="dates.start_date.min_date"
                  :icon-right="subEvent.startDateTime ? 'close-circle' : ''" icon-right-clickable
                  :locale="dates.start_date.locale" :first-day-of-week="dates.start_date.firstDayOfWeek"
                  :datepicker="{ showWeekNumber: dates.start_date.showWeekNumber }" :timepicker="{
                    enableSeconds: dates.start_date.enableSeconds,
                    hourFormat: dates.start_date.hourFormat,
                  }" horizontal-time-picker position="is-bottom-right">
                </b-datetimepicker>
              </b-field>
              <div class="h-spacer"></div>
              <b-field label="End Date Time" style="width: 100%">
                <b-datetimepicker v-model="subEvent.endDateTime" :min-datetime="subEvent.startDateTime"
                  placeholder="Click to select..." icon="calendar-today"
                  :icon-right="subEvent.endDateTime ? 'close-circle' : ''" icon-right-clickable
                  :locale="dates.end_date.locale" :first-day-of-week="dates.end_date.firstDayOfWeek"
                  :datepicker="{ showWeekNumber: dates.end_date.showWeekNumber }" :timepicker="{
                    enableSeconds: dates.end_date.enableSeconds,
                    hourFormat: dates.end_date.hourFormat,
                  }" horizontal-time-picker position="is-bottom-left">
                </b-datetimepicker>
              </b-field>
            </div>
            <div class="row" style="margin-top: 10px;">
              <b-button @click="removeSubEvent(index)" type="is-danger" size="is-small" icon-left="delete">
                Delete Sub Event
              </b-button>
            </div>
          </div>

          <div class="row" style="margin-top: 15px;">
            <b-button @click="addSubEvent" type="is-primary" icon-left="plus">
              Add Sub Event
            </b-button>
          </div>
        </div>
        <div class="row" v-if="!form.hasSubEvent">
          <b-field label="Location" style="width: 100%">
            <b-input v-model="form.location"></b-input>
          </b-field>
        </div>
        <div class="row" v-if="!form.hasSubEvent">
          <b-field label="Venue" style="width: 100%">
            <b-input v-model="form.venue"></b-input>
          </b-field>
        </div>


    


        <div class="row" style="margin-bottom: 20px">
          <b-field label="Visibility" style="width: 100%">
            <b-select v-model="form.status" placeholder="Select a visibility" expanded>
              <option v-for="option in visibilities" :value="option.value" :key="option.value">
                {{ option.name }}
              </option>
            </b-select>
          </b-field>
          <div class="h-spacer"></div>
          <b-field label="Allow Sell Tickets" style="width: 100%">
            <b-switch v-model="form.sell_tickets">
            </b-switch>
          </b-field>
        </div>

        <div class="row" style="margin-bottom: 20px">
          <b-field label="Allow Booking Form" style="width: 100%">
            <b-switch v-model="form.allowBookingForm">
            </b-switch>
          </b-field>
        </div>

        <div v-if="form.allowBookingForm" class="row" style="margin-bottom: 20px">
          <b-field label="Booking Limit" style="width: 100%"
            message="Maximum number of allowed bookings. Leave empty for unlimited.">
            <b-input v-model.number="form.bookingLimit" type="number" min="1" placeholder="Unlimited"></b-input>
          </b-field>
        </div>

        <div class="row" style="margin-bottom: 20px">
          <b-field label="Verify Ticket View" style="width: 100%"
            message="When enabled, customers must verify phone/email and transaction to view tickets. When disabled, ticket QR is shown directly on the website after booking.">
            <b-switch v-model="form.verifyPhoneOnTicketView">
            </b-switch>
          </b-field>
        </div>


      </div>

      <div class="form-modal-footer">
        <b-button :loading="submit_loading" @click="submitForm()" type="is-primary">
          SUBMIT
        </b-button>
        <b-button @click="onCancel" type="is-primary" outlined>CANCEL</b-button>
      </div>
    </div>
  </b-modal>
</template>
<script>
import { VueEditor } from "vue2-editor";
export default {
  components: {
    VueEditor
  },
  props: {
    value: {
      type: Object,
      default: null,
    },
    channel: {
      type: Object,
      default: null,
    }
  },
  data: () => ({
    isModalActive: true,
    dates: {
      start_date: {
        selected_date: new Date(),
        min_date: new Date(),
        showWeekNumber: false,
        enableSeconds: false,
        hourFormat: undefined, // Browser locale
        locale: undefined, // Browser locale
        firstDayOfWeek: undefined, // 0 - Sundays
      },
      end_date: {
        selected_date: new Date(),
        showWeekNumber: false,
        enableSeconds: false,
        hourFormat: undefined, // Browser locale
        locale: undefined, // Browser locale
        firstDayOfWeek: undefined, // 0 - Sunday
      },
    },
    visibilities: [
      {
        value: "public",
        name: "Public",
      },
      {
        value: "unlisted",
        name: "Unlisted",
      },
      {
        value: "private",
        name: "Private",
      },
    ],
    form: {
      title: "",
      description: "",
      bookingLink: "",
      customUssd: "",
      image: "",
      logo: "",
      channel_id: null,
      status: "unlisted",
      sell_tickets: false,
      allowBookingForm: false,
      bookingLimit: null,
      verifyPhoneOnTicketView: true,
      organizers: '',
      category: '',
      location: '',
      venue: '',
      coordinates: null,
      id: null,
      seasonEnabled: false,
      seasonCount: 1,
      hasSubEvent: false,
      subEvents: []
    },
    submit_loading: false,
  }),
  computed: {
    hasSubEventComputed: {
      get() {
        return this.form.hasSubEvent && this.form.subEvents.length > 0;
      },
      set(value) {
        this.form.hasSubEvent = value;
      }
    }
  },
  watch: {
    'form.hasSubEvent'(newVal) {
      let vm = this;
      if (newVal && vm.form.subEvents.length === 0) {
        vm.addSubEvent();
      } else if (!newVal) {
        vm.form.subEvents = [];
      }
    }
  },
  mounted() {
    let vm = this;
    if (vm.value) {
      vm.setFormFields();
    } else {
      vm.resetFormFields();
    }
  },
  beforeDestroy() {
    let vm = this;
  },
  methods: {
    setFormFields() {
      let vm = this;
      vm.form.title = vm.value.title;
      vm.form.channel_id = vm.channel.id;
      vm.form.description = vm.value.description;
      vm.form.bookingLink = vm.value.bookingLink;
      vm.form.customUssd = vm.value.customUssd;
      vm.form.image = vm.value.coverImage;
      vm.form.logo = vm.value.logoImage;
      vm.form.status = vm.value.status;
      vm.form.start_date = vm.value.startTime;
      vm.form.end_date = vm.value.endTime;
      vm.form.organizers = vm.value.organizers
      vm.form.category = vm.value.category
      vm.form.location = vm.value.location
      vm.form.venue = vm.value.venue
      vm.form.id = vm.value.id;
      vm.form.seasonEnabled = vm.value.seasonEnabled == 1 ? true : false;
      vm.form.seasonCount = vm.value.seasonCount;
      vm.form.hasSubEvent = vm.value.hasSubEvent == 1 ? true : false;
      vm.form.subEvents = (vm.value.subEvents || []).map(subEvent => ({
        ...subEvent,
        startDateTime: subEvent.startDateTime ? vm.moment(subEvent.startDateTime).toDate() : new Date(),
        endDateTime: subEvent.endDateTime ? vm.moment(subEvent.endDateTime).toDate() : new Date()
      }));
      vm.dates.start_date.selected_date = vm.value.startTime
        ? vm.moment(vm.value.startTime).toDate()
        : null;
      vm.dates.end_date.selected_date = vm.value.endTime
        ? vm.moment(vm.value.endTime).toDate()
        : null;
      vm.form.sell_tickets = vm.value.allowSellTicket == 1 ? true : false;
      vm.form.allowBookingForm = vm.value.allowBookingForm == 1 ? true : false;
      vm.form.bookingLimit = vm.value.bookingLimit ? Number(vm.value.bookingLimit) : null;
      vm.form.verifyPhoneOnTicketView = vm.value.verifyPhoneOnTicketView != 0;

      console.log("Form", vm.form);
    },
    resetFormFields() {
      let vm = this;
      vm.form = {
        title: "",
        description: "",
        bookingLink: "",
        customUssd: "",
        image: "",
        logo: "",
        channel_id: vm.channel.id,
        status: "unlisted",
        sell_tickets: false,
        allowBookingForm: false,
        bookingLimit: null,
        verifyPhoneOnTicketView: true,
        organizers: '',
        category: '',
        location: '',
        venue: '',
        coordinates: null,
        id: null,
        seasonEnabled: false,
        seasonCount: 1,
        hasSubEvent: false,
        subEvents: []
      };
    },
    submitForm() {
      let vm = this;
      // Start validate
      const rules = {
        title: {
          run: (value) => {
            if (!value) {
              return "Title is required";
            }
            return false;
          },
        },
        status: {
          run: (value) => {
            if (!value) {
              return "Status is required";
            }
            return false;
          },
        }
      };
      if (vm.$isFieldsValidated(vm.form, rules)) {
        if (vm.form.hasSubEvent) {
          for (let i = 0; i < vm.form.subEvents.length; i++) {
            if (!vm.form.subEvents[i].title || !vm.form.subEvents[i].title.trim()) {
              vm.$notify({
                group: "status",
                type: "warn",
                title: "Validation",
                text: `Sub event ${i + 1} title is required`,
              });
              return;
            }
          }
        }
        vm.submit_loading = true;
        let obj = {
          channelId: vm.form.channel_id,
          title: vm.form.title,
          description: vm.form.description,
          bookingLink: vm.form.bookingLink,
          customUssd: vm.form.customUssd,
          logoImage: vm.form.logo,
          coverImage: vm.form.image,
          startTime: vm.moment(vm.dates.start_date.selected_date).format("YYYY-MM-DD HH:mm:ss"),
          endTime: vm.moment(vm.dates.end_date.selected_date).format("YYYY-MM-DD HH:mm:ss"),
          status: vm.form.status,
          allowSellTicket: vm.form.sell_tickets,
          allowBookingForm: vm.form.allowBookingForm,
          bookingLimit: vm.form.allowBookingForm && vm.form.bookingLimit ? vm.form.bookingLimit : null,
          verifyPhoneOnTicketView: vm.form.verifyPhoneOnTicketView,
          id: vm.form.id,
          category: vm.form.category,
          organizers: vm.form.organizers,
          location: vm.form.location,
          venue: vm.form.venue,
          seasonEnabled: vm.form.seasonEnabled,
          seasonCount: vm.form.seasonCount,
          hasSubEvent: vm.form.hasSubEvent,
          subEvents: vm.form.subEvents.map(subEvent => ({
            ...subEvent,
            startDateTime: vm.moment(subEvent.startDateTime).format("YYYY-MM-DD HH:mm:ss"),
            endDateTime: vm.moment(subEvent.endDateTime).format("YYYY-MM-DD HH:mm:ss")
          }))
        }
        if (!vm.form.id) {
          vm.$store
            .dispatch("EVENTS_ADD_NEW_EVENT", obj)
            .then((response) => {
              vm.submit_loading = false;
              vm.$emit("success", response.data.return);
              vm.$notify({
                group: "status",
                type: "success",
                title: "Important message",
                text: response.data.message,
              });
            })
            .catch(({ response }) => {
              vm.submit_loading = false;
              vm.$notify({
                group: "status",
                type: "warn",
                title: "OOPS!!!",
                text: response.data.message,
              });
            });
        } else {
          vm.$store
            .dispatch("EVENTS_UPDATE_EVENT", obj)
            .then((response) => {
              vm.submit_loading = false;
              vm.$emit("success", response.data.return);
              vm.$notify({
                group: "status",
                type: "success",
                title: "Important message",
                text: response.data.message,
              });
            })
            .catch(({ response }) => {
              vm.submit_loading = false;
              vm.$notify({
                group: "status",
                type: "warn",
                title: "OOPS!!!",
                text: response.data.message,
              });
            });
        }
      }
    },
    onCancel() {
      let vm = this;
      vm.$emit("close");
    },
    addSubEvent() {
      let vm = this;
      vm.form.subEvents.push({
        title: "",
        image: "",
        location: "",
        venue: "",
        startDateTime: new Date(),
        endDateTime: new Date()
      });
    },
    removeSubEvent(index) {
      let vm = this;
      vm.form.subEvents.splice(index, 1);
    },
  },
};
</script>
<style lang="scss" scoped>
.form-modal-widget {
  width: 600px;
  background: #fff;
  margin: 20px auto;
  border-radius: 5px;

  @media (max-width: 628px) {
    width: 95% !important;

    .row {
      flex-direction: column;
    }
  }

  @media (max-width: 500px) {
    width: 100% !important;
    margin: 0;
  }

  .form-modal-header {
    height: 60px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #ddd;
    padding: 0px 20px;
    justify-content: space-between;

    @media (max-width: 500px) {
      position: sticky;
      top: 0;
      z-index: 10;
      background: white;
    }
  }

  .form-modal-body {
    padding: 10px 20px;
    min-height: 200px;
    padding-bottom: 30px;
  }

  .form-modal-footer {
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-top: 1px solid #ddd;
    padding: 0px 20px;
  }
}

#sideBartrue {
  left: 230px;

  @media (max-width: 768px) {
    left: 0;
  }

  .form-modal-widget {
    @media (max-width: 846px) {
      width: 500px;
    }

    @media (max-width: 768px) {
      width: 600px;
    }
  }
}
</style>